import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

export default {
  user: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER)) || {
    token: "",
    email: ""
  },
  appMode: process.env.VUE_APP_APP_MODE || "",
  status: "",
  planRestrictions: null
};
